import { render, staticRenderFns } from "./DescriptionListItemEdit.vue?vue&type=template&id=bb3bc95e&"
import script from "./DescriptionListItemEdit.vue?vue&type=script&lang=js&"
export * from "./DescriptionListItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports